import { dashboardAsset } from "./dashboardAssets";
import { ipfsToGatewayUrl } from "./ipfs";

export function getOsharReservationLocalFallback(reservation) {
  const t = `${reservation?.propertyTitle || ""} ${reservation?.metadataName || ""}`.toLowerCase();
  if (t.includes("commercial") && t.includes("storefront")) return dashboardAsset("02_commercial_storefront_card.png");
  if (t.includes("vendor") && t.includes("stall")) return dashboardAsset("03_vendor_stall_card.png");
  if (/forge|workshop|artisan/i.test(t)) return dashboardAsset("04_artisan_forge_card.png");
  if (t.includes("luxury") && t.includes("residence")) return dashboardAsset("05_luxury_residence_card.png");
  return dashboardAsset("01_hero_oshar_city_spires.png");
}

/**
 * Image URL for My Oshar Access cards.
 * Priority: assigned row imageUrl (unique art after backfill) → live metadata gateway image → tier Stripe imageUrl
 * → snapshot → composite imageGatewayUrl → local cinematic fallback.
 * @param {Record<string, unknown>} reservation
 * @returns {string}
 */
export function getOsharReservationImage(reservation) {
  const r = reservation || {};
  const tid = r.tokenId != null ? String(r.tokenId) : "?";

  const assignedHttps =
    r.metadataStatus === "assigned" && r.imageUrl && String(r.imageUrl).trim() && /^https?:\/\//i.test(String(r.imageUrl).trim())
      ? String(r.imageUrl).trim()
      : null;
  if (assignedHttps) {
    return assignedHttps;
  }

  if (r.metadataImageGatewayUrl && typeof r.metadataImageGatewayUrl === "string") {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.info(`[OsharAccess] Using IPFS metadata image for tokenId ${tid}`);
    }
    return r.metadataImageGatewayUrl;
  }

  const direct = r.imageUrl && String(r.imageUrl).trim();
  if (direct && /^https?:\/\//i.test(direct)) {
    return direct.trim();
  }

  const rowIpfsImg = r.imageIpfsUri && String(r.imageIpfsUri).trim();
  if (rowIpfsImg && rowIpfsImg.startsWith("ipfs://")) {
    const g = ipfsToGatewayUrl(rowIpfsImg);
    if (g) return g;
  }

  const snapGw = r.metadataSnapshot?.imageGatewayUrl;
  if (snapGw && typeof snapGw === "string") {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.info(`[OsharAccess] Using snapshot gateway image for tokenId ${tid}`);
    }
    return snapGw;
  }

  const snapIpfs = r.metadataSnapshot?.image;
  if (snapIpfs && typeof snapIpfs === "string") {
    const g = ipfsToGatewayUrl(snapIpfs.trim());
    if (g) {
      if (process.env.NODE_ENV === "development") {
        // eslint-disable-next-line no-console
        console.info(`[OsharAccess] Using snapshot IPFS→gateway image for tokenId ${tid}`);
      }
      return g;
    }
    if (/^https?:\/\//i.test(snapIpfs.trim())) {
      return snapIpfs.trim();
    }
  }

  if (r.imageGatewayUrl && typeof r.imageGatewayUrl === "string") {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.info(`[OsharAccess] Using imageGatewayUrl for tokenId ${tid}`);
    }
    return r.imageGatewayUrl;
  }

  const fb = getOsharReservationLocalFallback(r);
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.info(`[OsharAccess] Falling back to local image for tokenId ${tid}`);
  }
  return fb;
}
